import { render } from "./OverlayRegisterUSAE.vue?vue&type=template&id=32309ebc&scoped=true&ts=true"
import script from "./OverlayRegisterUSAE.vue?vue&type=script&lang=ts"
export * from "./OverlayRegisterUSAE.vue?vue&type=script&lang=ts"

import "./OverlayRegisterUSAE.vue?vue&type=style&index=0&id=32309ebc&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32309ebc"]])

export default __exports__